
(function () {
  /*
   * Aquariumer AMI
   * 2026年10月更新版
   * 85対象・2026年3月〜10月
   *
   * データ形式：
   * [名称, よみがな, 五十音グループ, ID, 単位, n, 月別価格]
   *
   * 月別価格：
   * 9月開始 → [9月, 10月]
   * 3月開始 → [3月, 4月, 5月, 6月, 7月, 8月, 9月, 10月]
   *
   * null = 欠測
   * n = 2026年10月の独立販売元数
   */

  const rawData = [
    ["アナカリス","あなかりす","あ行","anacharis","10本",6,[750,749,680,680,680,710,620,720]],
    ["マツモ","まつも","ま行","ami-2","3本",5,[396,253.846153846]],
    ["カボンバ","かぼんば","か行","cabomba","5本",5,[505,690,640,505,505,505,314.5,330]],
    ["アマゾンフロッグピット","あまぞんふろっぐぴっと","あ行","amazon-frogbit","5株",5,[300,300,300,352,336,336,528,550]],
    ["サルビニア・ククラータ","さるびにあくくらーた","さ行","salvinia-cucullata","5株",4,[880,880,750,750,698,980,662.17,829.166666667]],
    ["ドワーフフロッグビット","どわーふふろっぐびっと","た行","ami-6","5株",5,[394.17,458.333333333]],
    ["オオサンショウモ","おおさんしょうも","あ行","ami-7","5株",5,[630,810]],
    ["ホテイアオイ","ほていあおい","は行","ami-8","3株",5,[396,495]],
    ["ウォータースプライト","うぉーたーすぷらいと","あ行","water-sprite","3株",2,[750,1284,1284,1284,1284,1284,550,517.5]],
    ["ウォーターダイヤ","うぉーたーだいや","あ行","water-diamond","1株",1,[1670,1670,899,780,750,750,623.5,447]],
    ["アヌビアス・ナナ","あぬびあすなな","あ行","anubias-nana","1株",2,[393,600,493,600,600,600,350,350]],
    ["アヌビアス・ナナ プチ","あぬびあすななぷち","あ行","anubias-nana-petite","1株",2,[400,400,470,293,376,293,210,269]],
    ["アヌビアス・バルテリー","あぬびあすばるてりー","あ行","ami-13","1株",0,[null,null]],
    ["アヌビアス・コーヒーフォリア","あぬびあすこーひーふぉりあ","あ行","ami-14","1株",0,[null,null]],
    ["アヌビアス・ゴールデン","あぬびあすごーるでん","あ行","ami-15","1株",1,[463.33,478]],
    ["ミクロソリウム・プテロプス","みくろそりうむぷてろぷす","ま行","ami-16","1株",1,[254.17,275]],
    ["ミクロソリウム・ウェンディロフ","みくろそりうむうぇんでぃろふ","ま行","ami-17","1株",1,[220,220]],
    ["ミクロソリウム・ナローリーフ","みくろそりうむなろーりーふ","ま行","ami-18","1株",1,[293.33,293.333333333]],
    ["ミクロソリウム・トライデント","みくろそりうむとらいでんと","ま行","ami-19","1株",1,[1850,1850]],
    ["ボルビティス・ヒュディロティ","ぼるびてぃすひゅでぃろてぃ","は行","ami-20","1株",3,[1840,1840]],
    ["ウィローモス","うぃろーもす","あ行","ami-21","1パック",4,[548.5,639.5]],
    ["南米ウィローモス","なんべいうぃろーもす","な行","ami-22","1パック",2,[880,739]],
    ["ジャワモス","じゃわもす","さ行","ami-23","1パック",1,[1487.5,550]],
    ["フレイムモス","ふれいむもす","は行","ami-24","1パック",1,[1226.67,1580]],
    ["クリスマスモス","くりすますもす","か行","ami-25","1パック",1,[1060,1430]],
    ["リシア","りしあ","ら行","ami-26","1パック",1,[365,880]],
    ["ニューラージパールグラス","にゅーらーじぱーるぐらす","な行","ami-27","1通常販売単位",3,[889,798]],
    ["キューバパールグラス","きゅーばぱーるぐらす","か行","ami-28","1通常販売単位",5,[980,900]],
    ["グロッソスティグマ","ぐろっそすてぃぐま","か行","ami-29","1パック",3,[980,798]],
    ["ショートヘアーグラス","しょーとへあーぐらす","さ行","ami-30","1パック",4,[798,744]],
    ["ヘアーグラス","へあーぐらす","は行","ami-31","1パック",2,[1040,842.5]],
    ["ピグミーチェーンサジタリア","ぴぐみーちぇーんさじたりあ","は行","ami-33","3株",1,[675,600]],
    ["パールグラス","ぱーるぐらす","は行","ami-36","5本",5,[570,550]],
    ["ラージパールグラス","らーじぱーるぐらす","ら行","ami-37","5本",3,[506,200]],
    ["ロタラ・ロトンディフォリア","ろたらろとんでぃふぉりあ","ら行","ami-38","10本",3,[1460,740]],
    ["ロタラ・インディカ","ろたらいんでぃか","ら行","ami-39","10本",5,[798,600]],
    ["ロタラ・グリーン","ろたらぐりーん","ら行","ami-40","10本",3,[924,519.2]],
    ["ロタラ・Hra","ろたらhra","ら行","ami-41","10本",2,[1045,784]],
    ["ルドウィジア・レペンス","るどうぃじあれぺんす","ら行","ami-44","5本",2,[875,350]],
    ["ルドウィジア・スーパーレッド","るどうぃじあすーぱーれっど","ら行","ami-45","5本",4,[475,327.777777778]],
    ["ルドウィジア・オバリス","るどうぃじあおばりす","ら行","ami-46","5本",3,[370,343.75]],
    ["ハイグロフィラ・ポリスペルマ","はいぐろふぃらぽりすぺるま","は行","ami-47","5本",5,[460,375]],
    ["ハイグロフィラ・ロザエネルビス","はいぐろふぃらろざえねるびす","は行","ami-48","3本",4,[415.65,397.65]],
    ["ハイグロフィラ・ピンナティフィダ","はいぐろふぃらぴんなてぃふぃだ","は行","ami-49","3本",2,[1747.5,1327]],
    ["アンブリア","あんぶりあ","あ行","ami-51","5本",3,[748,343.75]],
    ["バコパ・モンニエリ","ばこぱもんにえり","は行","ami-53","5本",3,[490,300]],
    ["アルテルナンテラ・レインキー","あるてるなんてられいんきー","あ行","ami-55","5本",3,[460,370]],
    ["マヤカ","まやか","ま行","ami-58","5本",2,[550,447.5]],
    ["ポゴステモン・ヘルフェリー","ぽごすてもんへるふぇりー","は行","ami-60","3株",2,[1775.5,890]],
    ["アマゾンソード","あまぞんそーど","あ行","amazon-sword","1株",3,[750,985,750,750,985,999,539,475]],
    ["スクリューバリスネリア","すくりゅーばりすねりあ","さ行","ami-65","5株",3,[660,660]],
    ["クリプトコリネ・ウェンティー グリーン","くりぷとこりねうぇんてぃーぐりーん","か行","ami-68","1株",3,[null,440]],
    ["ナヤス","なやす","な行","najas","5本",3,[750,750,750,750,750,1100,988,850]],
    ["ヤマサキカズラ","やまさきかずら","や行","ami-76","1本",3,[1105,1040]],
    ["ウォーターマッシュルーム","うぉーたーまっしゅるーむ","あ行","water-mushroom","5本",2,[572,572,580,580,580,580,539,434]],
    ["ウォーターバコパ","うぉーたーばこぱ","あ行","ami-78","5本",4,[370,321.875]],
    ["ブセファランドラ・クダガン","ぶせふぁらんどらくだがん","は行","ami-79","1株",6,[1800,1505]],
    ["ブセファランドラ・ティア","ぶせふぁらんどらてぃあ","は行","ami-80","1株",2,[null,1055.5]],
    ["ブセファランドラ・グリーンベルベット","ぶせふぁらんどらぐりーんべるべっと","は行","ami-81","1株",2,[2480,1795.5]],
    ["ブセファランドラ・ビブリス","ぶせふぁらんどらびぶりす","は行","ami-82","1株",4,[2150,1055.5]],
    ["ブセファランドラ・ラマンダウ","ぶせふぁらんどららまんだう","は行","ami-83","1株",1,[null,1111]],
    ["ブセファランドラ・ソルディデュラブルー","ぶせふぁらんどらそるでぃでゅらぶるー","は行","ami-84","1株",1,[null,3999.5]],
    ["ブセファランドラ・ブラウニーゴースト","ぶせふぁらんどらぶらうにーごーすと","は行","ami-85","1株",0,[null,null]],
    ["ブリクサ・ショートリーフ","ぶりくさしょーとりーふ","は行","ami-90","3株",2,[948.75,1051.5]],
    ["ヒメダカ","ひめだか","は行","ami-91","10匹",5,[612.5,625]],
    ["黒メダカ","くろめだか","か行","ami-92","10匹",5,[772,566.666666667]],
    ["白メダカ","しろめだか","さ行","ami-93","10匹",5,[1155,990]],
    ["青メダカ","あおめだか","あ行","ami-94","10匹",5,[1540,740]],
    ["楊貴妃メダカ","ようきひめだか","や行","ami-95","10匹",5,[2530,1275]],
    ["幹之メダカ","みゆきめだか","ま行","ami-96","10匹",2,[1295,1985]],
    ["オロチメダカ","おろちめだか","あ行","ami-98","5匹",6,[1975,2235]],
    ["ネオンテトラ","ねおんてとら","な行","ami-111","10匹",5,[800,698]],
    ["カージナルテトラ","かーじなるてとら","か行","ami-112","10匹",5,[1410,1280]],
    ["ラミーノーズテトラ","らみーのーずてとら","ら行","ami-114","10匹",5,[1450,1280]],
    ["アカヒレ","あかひれ","あ行","ami-121","10匹",3,[1425,1100]],
    ["コリドラス・パンダ","こりどらすぱんだ","か行","ami-126","3匹",5,[1360,1360]],
    ["コリドラス・ステルバイ","こりどらすすてるばい","か行","ami-128","3匹",5,[2840,2490]],
    ["オトシンクルス","おとしんくるす","あ行","ami-129","3匹",5,[990,917]],
    ["ミナミヌマエビ","みなみぬまえび","ま行","ami-136","10匹",5,[980,380]],
    ["ヤマトヌマエビ","やまとぬまえび","や行","ami-137","10匹",5,[1955,680]],
    ["レッドビーシュリンプ","れっどびーしゅりんぷ","ら行","ami-138","5匹",5,[1750,1990]],
    ["チェリーシュリンプ","ちぇりーしゅりんぷ","た行","ami-139","10匹",5,[2200,1540]],
    ["石巻貝","いしまきがい","あ行","ami-146","10匹",5,[685,600]],
    ["ヒメタニシ","ひめたにし","は行","ami-147","10匹",5,[1070,980]],
    ["レッドラムズホーン","れっどらむずほーん","ら行","ami-148","5匹",5,[694,500]]
  ];

  // 元コードと同じオブジェクト構造へ変換
  const aqMarketData = rawData.map(function (row) {
    const prices = row[6];
    const startMonth = prices.length === 8 ? 3 : 9;

    return {
      name: row[0],
      kana: row[1],
      group: row[2],
      id: row[3],
      unit: row[4],
      n: row[5],
      monthly: prices.map(function (median, index) {
        return {
          month: "2026年" + (startMonth + index) + "月",
          median: median
        };
      })
    };
  });

  const RANGE_RATE = 0.2;
  const RANGE_ROUND_UNIT = 50;

  const groupOrder = [
    "あ行", "か行", "さ行", "た行", "な行",
    "は行", "ま行", "や行", "ら行", "わ行"
  ];

  const groupIdMap = {
    "あ行": "a",
    "か行": "ka",
    "さ行": "sa",
    "た行": "ta",
    "な行": "na",
    "は行": "ha",
    "ま行": "ma",
    "や行": "ya",
    "ら行": "ra",
    "わ行": "wa"
  };

  function normalizeText(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      })
      .replace(/\s+/g, "");
  }

  function yen(value) {
    if (
      value === null ||
      value === undefined ||
      Number.isNaN(Number(value))
    ) {
      return "—";
    }

    return Number(value).toLocaleString("ja-JP", {
      maximumFractionDigits: 2
    }) + "円";
  }

  function latestOf(item) {
    return item.monthly[item.monthly.length - 1];
  }

  function roundDownToUnit(value, unit) {
    return Math.floor(value / unit) * unit;
  }

  function roundUpToUnit(value, unit) {
    return Math.ceil(value / unit) * unit;
  }

  function rangeOf(row) {
    if (
      !row ||
      row.median === null ||
      row.median === undefined ||
      Number.isNaN(Number(row.median))
    ) {
      return { low: null, high: null };
    }

    const median = Number(row.median);

    return {
      low: Math.max(
        0,
        roundDownToUnit(
          median * (1 - RANGE_RATE),
          RANGE_ROUND_UNIT
        )
      ),
      high: roundUpToUnit(
        median * (1 + RANGE_RATE),
        RANGE_ROUND_UNIT
      )
    };
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (match) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[match];
    });
  }

  function getDisplayData() {
    const root = document.getElementById("aq-ami-top");

    if (!root) {
      return aqMarketData;
    }

    const mode = root.getAttribute("data-ami-mode") || "full";
    const idsText = root.getAttribute("data-ami-ids") || "";

    // 個別商品指定がある場合
    if (idsText.trim() !== "") {
      const allowedIds = idsText
        .split(",")
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean);

      return aqMarketData
        .filter(function (item) {
          return allowedIds.indexOf(item.id) !== -1;
        })
        .map(function (item) {
          if (mode === "limited") {
            return Object.assign({}, item, {
              monthly: item.monthly.slice(-2)
            });
          }

          return item;
        });
    }

    // プレミアム版
    if (mode !== "limited") {
      return aqMarketData;
    }

    // 無料会員版：17対象
    const freeIds = [
      "anacharis",
      "ami-2",
      "cabomba",
      "amazon-frogbit",
      "ami-8",
      "ami-21",
      "ami-27",
      "amazon-sword",
      "ami-91",
      "ami-95",
      "ami-96",
      "ami-111",
      "ami-112",
      "ami-129",
      "ami-136",
      "ami-137",
      "ami-148"
    ];

    return aqMarketData
      .filter(function (item) {
        return freeIds.indexOf(item.id) !== -1;
      })
      .map(function (item) {
        return Object.assign({}, item, {
          monthly: item.monthly.slice(-2)
        });
      });
  }

  function makeMiniChart(monthly) {
    const valid = monthly.filter(function (row) {
      return row.median !== null &&
        row.median !== undefined &&
        !Number.isNaN(Number(row.median));
    });

    if (!valid.length) {
      return '<div class="aq-ami-no-data">価格データなし</div>';
    }

    const values = valid.map(function (row) {
      return Number(row.median);
    });

    const min = Math.min.apply(null, values);
    const max = Math.max.apply(null, values);
    const range = Math.max(max - min, 1);

    const width = 180;
    const height = 28;
    const pad = 3;

    const points = values.map(function (value, index) {
      const x = pad + (
        index *
        ((width - pad * 2) / Math.max(values.length - 1, 1))
      );

      const y = height - pad -
        ((value - min) / range) * (height - pad * 2);

      return x + "," + y;
    }).join(" ");

    return ''
      + '<svg class="aq-ami-mini-chart" viewBox="0 0 '
      + width + ' ' + height
      + '" aria-hidden="true">'
      + '<polyline points="' + points
      + '" fill="none" stroke="#1976d2" stroke-width="3"'
      + ' stroke-linecap="round" stroke-linejoin="round">'
      + '</polyline></svg>';
  }

  function makeMainChart(monthly) {
    const validMonthly = monthly.slice(-12).filter(function (row) {
      return row.median !== null &&
        row.median !== undefined &&
        !Number.isNaN(Number(row.median));
    });

    if (!validMonthly.length) {
      return '<div class="aq-ami-no-data aq-ami-no-data-main">'
        + '現在、掲載できる価格データがありません。'
        + '</div>';
    }

    const plotMonthly = validMonthly;

    const width = 420;
    const height = 260;

    const pad = {
      top: 30,
      right: 28,
      bottom: 46,
      left: 54
    };

    const plotW = width - pad.left - pad.right;
    const plotH = height - pad.top - pad.bottom;

    const lows = plotMonthly.map(function (row) {
      return rangeOf(row).low;
    });

    const highs = plotMonthly.map(function (row) {
      return rangeOf(row).high;
    });

    const minRaw = Math.min.apply(null, lows);
    const maxRaw = Math.max.apply(null, highs);

    const minY = Math.max(
      0,
      Math.floor(minRaw / 100) * 100
    );

    const maxY = Math.ceil(maxRaw / 100) * 100;
    const range = Math.max(maxY - minY, 1);

    function x(index) {
      return pad.left + (
        index *
        (plotW / Math.max(plotMonthly.length - 1, 1))
      );
    }

    function y(value) {
      return pad.top +
        (maxY - value) / range * plotH;
    }

    const highPoints = plotMonthly.map(function (row, index) {
      return x(index) + "," + y(rangeOf(row).high);
    });

    const lowPoints = plotMonthly
      .slice()
      .reverse()
      .map(function (row, reverseIndex) {
        const index = plotMonthly.length - 1 - reverseIndex;
        return x(index) + "," + y(rangeOf(row).low);
      });

    const bandPoints = highPoints
      .concat(lowPoints)
      .join(" ");

    const medianPoints = plotMonthly.map(function (row, index) {
      return x(index) + "," + y(row.median);
    }).join(" ");

    const tickCount = 4;

    const ticks = Array.from(
      { length: tickCount + 1 },
      function (_, i) {
        return Math.round(
          (minY + (range / tickCount) * i) / 10
        ) * 10;
      }
    );

    const grid = ticks.map(function (value) {
      const ty = y(value);

      return ''
        + '<line x1="' + pad.left
        + '" y1="' + ty
        + '" x2="' + (width - pad.right)
        + '" y2="' + ty
        + '" stroke="#e5e7eb" stroke-width="1"></line>'
        + '<text x="' + (pad.left - 8)
        + '" y="' + (ty + 4)
        + '" text-anchor="end" font-size="10" fill="#666">'
        + yen(value)
        + '</text>';
    }).join("");

    const latestIndex = plotMonthly.length - 1;
    const latest = plotMonthly[latestIndex];

    const latestX = x(latestIndex);
    const latestY = y(latest.median);

    const labels = plotMonthly.map(function (row, index) {
      const label = String(row.month).replace(/^\d{4}年/, "");

      return '<text x="' + x(index)
        + '" y="' + (height - 18)
        + '" text-anchor="middle" font-size="10" fill="#666">'
        + escapeHtml(label)
        + '</text>';
    }).join("");

    const dots = plotMonthly.map(function (row, index) {
      if (index === latestIndex) {
        return ''
          + '<circle cx="' + x(index)
          + '" cy="' + y(row.median)
          + '" r="8" fill="#ffffff" stroke="#1976d2"'
          + ' stroke-width="3"></circle>'
          + '<circle cx="' + x(index)
          + '" cy="' + y(row.median)
          + '" r="4" fill="#1976d2"></circle>';
      }

      return '<circle cx="' + x(index)
        + '" cy="' + y(row.median)
        + '" r="3.5" fill="#1976d2"></circle>';
    }).join("");

    const latestLabelX = Math.min(
      latestX,
      width - pad.right - 52
    );

    const latestLabelY = Math.max(
      latestY - 14,
      22
    );

    return ''
      + '<svg class="aq-ami-chart" viewBox="0 0 '
      + width + ' ' + height
      + '" role="img"'
      + ' aria-label="中央値と参考価格レンジの推移グラフ">'
      + '<rect x="0" y="0" width="' + width
      + '" height="' + height
      + '" fill="#fbfdff"></rect>'
      + grid
      + '<polygon points="' + bandPoints
      + '" fill="#90caf9" opacity="0.25"></polygon>'
      + '<polyline points="' + medianPoints
      + '" fill="none" stroke="#1976d2" stroke-width="3.5"'
      + ' stroke-linecap="round" stroke-linejoin="round"></polyline>'
      + dots
      + '<text x="' + latestLabelX
      + '" y="' + latestLabelY
      + '" text-anchor="middle" font-size="11"'
      + ' fill="#1976d2" font-weight="700">最新 '
      + yen(latest.median)
      + '</text>'
      + labels
      + '<text x="' + pad.left
      + '" y="18" font-size="11" fill="#1976d2"'
      + ' font-weight="700">中央値</text>'
      + '<rect x="' + (pad.left + 52)
      + '" y="9" width="16" height="9"'
      + ' fill="#90caf9" opacity="0.25"></rect>'
      + '<text x="' + (pad.left + 74)
      + '" y="18" font-size="11" fill="#666">'
      + '参考価格レンジ</text>'
      + '</svg>';
  }

  function rangeText(row) {
    const r = rangeOf(row);

    if (r.low === null || r.high === null) {
      return "—";
    }

    return yen(r.low) + "〜" + yen(r.high);
  }

  function renderCards(data) {
    const cardsRoot = document.getElementById("aq-ami-cards");
    const indexRoot = document.getElementById("aq-ami-index");

    if (!cardsRoot || !indexRoot) {
      return;
    }

    const sorted = data.slice().sort(function (a, b) {
      return a.kana.localeCompare(b.kana, "ja");
    });

    const activeGroups = groupOrder.filter(function (group) {
      return sorted.some(function (item) {
        return item.group === group;
      });
    });

    indexRoot.innerHTML = activeGroups.map(function (group) {
      const groupId = groupIdMap[group] || group;

      return '<a href="#ami-group-' + groupId + '">'
        + group.replace("行", "")
        + '</a>';
    }).join("");

    cardsRoot.innerHTML = activeGroups.map(function (group) {
      const groupId = groupIdMap[group] || group;

      const items = sorted.filter(function (item) {
        return item.group === group;
      });

      const cards = items.map(function (item) {
        const latest = latestOf(item);

        const searchText = normalizeText(
          item.name + " " + item.kana + " " + item.unit
        );

        return ''
          + '<a class="aq-ami-card"'
          + ' data-ami-search="' + escapeHtml(searchText) + '"'
          + ' href="#ami-' + escapeHtml(item.id) + '">'
          + '<div class="aq-ami-card-name">'
          + escapeHtml(item.name)
          + '</div>'
          + '<div class="aq-ami-card-unit">'
          + escapeHtml(item.unit)
          + '</div>'
          + '<div class="aq-ami-card-median">'
          + escapeHtml(latest.month)
          + 'の中央値<strong>'
          + yen(latest.median)
          + '</strong></div>'
          + '<div class="aq-ami-card-range">'
          + (
            latest.median === null ||
            latest.median === undefined
              ? '有効な価格データなし'
              : '参考価格レンジ：' + rangeText(latest)
          )
          + '</div>'
          + makeMiniChart(item.monthly)
          + '</a>';
      }).join("");

      return ''
        + '<section id="ami-group-' + groupId
        + '" class="aq-ami-group">'
        + '<h4 class="aq-ami-group-title">'
        + group
        + '</h4>'
        + '<div class="aq-ami-card-grid">'
        + cards
        + '</div>'
        + '</section>';
    }).join("");
  }

  function renderDetails(data) {
    const detailsRoot = document.getElementById("aq-ami-details");

    if (!detailsRoot) {
      return;
    }

    const sorted = data.slice().sort(function (a, b) {
      return a.kana.localeCompare(b.kana, "ja");
    });

    detailsRoot.innerHTML = sorted.map(function (item) {
      const latest = latestOf(item);

      const rows = item.monthly.map(function (row) {
        const rowRange = rangeOf(row);

        return ''
          + '<tr>'
          + '<td>' + escapeHtml(row.month) + '</td>'
          + '<td>' + yen(row.median) + '</td>'
          + '<td>' + yen(rowRange.low) + '</td>'
          + '<td>' + yen(rowRange.high) + '</td>'
          + '</tr>';
      }).join("");

      return ''
        + '<section id="ami-' + escapeHtml(item.id)
        + '" class="aq-ami-chap">'
        + '<div class="aq-ami-chap-head">'
        + '<h3>' + escapeHtml(item.name)
        + 'の相場推移</h3>'
        + '<div class="aq-ami-unit">'
        + escapeHtml(item.unit)
        + '</div>'
        + '</div>'
        + '<div class="aq-ami-stats">'
        + '<div class="aq-ami-stat">'
        + '<span class="aq-ami-stat-label">'
        + escapeHtml(latest.month)
        + 'の中央値</span>'
        + '<span class="aq-ami-stat-value">'
        + yen(latest.median)
        + '</span>'
        + '</div>'
        + '<div class="aq-ami-stat">'
        + '<span class="aq-ami-stat-label">参考価格レンジ</span>'
        + '<span class="aq-ami-stat-value">'
        + rangeText(latest)
        + '</span>'
        + '</div>'
        + '</div>'
        + '<div class="aq-ami-chart-wrap">'
        + makeMainChart(item.monthly)
        + '</div>'
        + '<table class="aq-ami-table">'
        + '<thead><tr>'
        + '<th>月</th>'
        + '<th>中央値</th>'
        + '<th>下限目安</th>'
        + '<th>上限目安</th>'
        + '</tr></thead>'
        + '<tbody>'
        + rows
        + '</tbody>'
        + '</table>'
        + '</section>';
    }).join("");
  }

  function filterAmi() {
    const input = document.getElementById("ami-search-input");
    const cards = document.querySelectorAll(".aq-ami-card");
    const groups = document.querySelectorAll(".aq-ami-group");

    if (!input) {
      return;
    }

    const query = normalizeText(input.value);
    let hitCount = 0;

    cards.forEach(function (card) {
      const matched = !query ||
        (card.dataset.amiSearch || "").indexOf(query) !== -1;

      card.classList.toggle("ami-hidden", !matched);
      card.classList.toggle("ami-hit", !!query && matched);

      if (matched) {
        hitCount++;
      }
    });

    groups.forEach(function (group) {
      const visibleCards = group.querySelectorAll(
        ".aq-ami-card:not(.ami-hidden)"
      );

      group.classList.toggle(
        "ami-hidden",
        !!query && visibleCards.length === 0
      );
    });

    let noResult = document.getElementById("ami-no-result");

    if (!noResult) {
      noResult = document.createElement("div");
      noResult.id = "ami-no-result";
      noResult.className = "ami-no-result ami-hidden";
      noResult.textContent =
        "該当する対象が見つかりませんでした。別のキーワードで検索してください。";

      const cardsRoot = document.getElementById("aq-ami-cards");

      if (cardsRoot) {
        cardsRoot.appendChild(noResult);
      }
    }

    noResult.classList.toggle(
      "ami-hidden",
      !query || hitCount > 0
    );
  }

  function bindSearch() {
    const input = document.getElementById("ami-search-input");

    if (!input || input.dataset.amiBound) {
      return;
    }

    input.dataset.amiBound = "true";

    input.addEventListener("input", function () {
      filterAmi();
    });
  }

  function initAmi() {
    const displayData = getDisplayData();

    renderCards(displayData);
    renderDetails(displayData);
    bindSearch();
    filterAmi();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAmi);
  } else {
    initAmi();
  }

  setTimeout(initAmi, 100);

  document.addEventListener("shopify:section:load", function () {
    initAmi();
  });

})();
